import { Injectable } from "@angular/core";
import { ArrayHelper, Tools } from "@comunicare/comunicare-helper";
import { IRewardScore, IRewardScoreExtended } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { BaseApiService } from "./baseApi.service";

@Injectable({
  providedIn: "root",
})
export class RewardScoreApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "IRewardScore", // Theme !
      [], // Post route paths
      ["rewardScoresByPatient", "rewardScoresByService"], // Get route paths
      ["rewardScore"], // Put route paths
      [] // Delete route paths
    );
  }

  public listRewardScoresByPatient(
    patientId: string,
    startDate: string,
    endDate: string,
    onlyInProgress: boolean
  ): Observable<IRewardScore[]> {
    return this.api.get(this.readRoutes[0], {
      patientId,
      startDate,
      endDate,
      onlyInProgress,
    }) as Observable<IRewardScore[]>;
  }

  public listRewardScoresByService(
    serviceId: string,
    startDate: string,
    endDate: string,
    onlyInProgress: boolean,
    services?: string[],
    monitoringServicesIds?: string[]
  ): Observable<IRewardScoreExtended[]> {
    const params: any = {
      serviceId,
      startDate,
      endDate,
      onlyInProgress,
    };
    if (Tools.isDefined(services) && !ArrayHelper.isEmpty(services)) {
      params.services = JSON.stringify(services);
    }
    if (Tools.isDefined(monitoringServicesIds) && !ArrayHelper.isEmpty(monitoringServicesIds)) {
      params.monitoringServicesIds = monitoringServicesIds.join();
    }
    return this.api.get(this.readRoutes[1], params) as Observable<IRewardScoreExtended[]>;
  }

  public updateRewardScore(rewardScore: IRewardScore): Observable<IRewardScore> {
    return this.api.put(this.updateRoutes[0], rewardScore) as Observable<IRewardScore>;
  }
}
